import OutlinedButton from "@/components/button/OutlinedButton";
import { GOI_SERVICE_URL } from "@/constants/url";
import { NextLink, VStack } from "goi_common";

const FuneralGuidebook = () => {
  return (
    <VStack
      css={{
        marginTop: "40px",
      }}
      gap="16px"
      className="white"
      as="section"
    >
      <p className="body_14_r">
        고이는 장례에 준비하는 데 필요한 양질의 정보 글들을 많이 발행하는 것으로 알려져 있다.
      </p>
      <NextLink href={`${GOI_SERVICE_URL}/guidebook/`}>
        <OutlinedButton size="medium" className="subtitle_18_b" fullWidth>
          장례 가이드북
        </OutlinedButton>
      </NextLink>
    </VStack>
  );
};

export default FuneralGuidebook;
